import styled from "@emotion/styled";

interface Props {
  inline?: boolean;
}

export const ControlButtonContainerStyled = styled.div<Props>`
  width: ${(props) => (props.inline ? "auto" : "100%")};
  height: 100%;
  min-width: ${(props) => (props.inline ? "auto" : "136px")};
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  column-gap: 4px;
  row-gap: 4px;
  flex-wrap: wrap;
  flex-shrink: 0;
`;
